/**
 * Mensajes de seguridad: autenticación de dos factores (2FA) y configuración
 * segura de métodos de pago.
 */

export const twoFactor = {
  // Títulos / descripciones
  sectionTitle: 'Autenticación de dos factores (2FA)',
  sectionDescriptionPrefix: 'Agrega una capa extra de seguridad. ',
  sectionDescriptionStrong:
    'Es obligatorio para modificar las credenciales de métodos de pago.',
  enabledBadge: '2FA está activado en tu cuenta.',
  disableSummary: 'Desactivar 2FA',
  activateButton: 'Activar 2FA',
  manualKeyHint: '¿No puedes escanear? Ingresa esta clave manualmente:',
  scanHint: 'Escanéalo con Google Authenticator',
  qrAlt: 'Código QR para 2FA',
  backupCodesTitle: 'Códigos de respaldo',
  backupCodesWarning:
    'Guárdalos en un lugar seguro: te permiten entrar si pierdes el teléfono.',
  confirmInstruction:
    'Ingresa el código de 6 dígitos que muestra tu app para confirmar:',
  confirmActivateButton: 'Confirmar y activar',
  disableButton: 'Desactivar',
  verifying: 'Verificando...',
  copy: 'Copiar',
  copied: 'Copiado',
  codePlaceholder: 'Código de 6 dígitos',
  // Toasts
  setupError: 'No se pudo iniciar la configuración de 2FA.',
  codeRequired: 'Ingresa el código de 6 dígitos de tu app.',
  enabledOk: '2FA habilitado correctamente.',
  invalidCode: 'Código inválido. Intenta de nuevo.',
  disableCodeRequired: 'Ingresa un código 2FA válido para desactivar.',
  disabledOk: '2FA desactivado.',
  disableError: 'No se pudo desactivar el 2FA.',
} as const;

export const paymentConfigMessages = {
  securityNote:
    'Las credenciales secretas se cifran y nunca se muestran completas. Cambiarlas requiere 2FA.',
  modalTitle: 'Verificación de seguridad',
  modalInstruction:
    'Para cambiar las credenciales de pago, ingresa el código de 6 dígitos de tu aplicación de autenticación (2FA).',
  confirmSaveButton: 'Confirmar y guardar',
  verifying: 'Verificando...',
  closeAria: 'Cerrar verificación',
  // Toasts
  twoFactorDisabled:
    'Debes habilitar la autenticación de dos factores (2FA) en tu perfil antes de modificar credenciales de pago.',
  twoFactorInvalid: 'Código 2FA inválido o expirado. Intenta nuevamente.',
  codeRequired: 'Ingresa el código de 6 dígitos de tu app de autenticación.',
} as const;
